import { render } from "./list.vue?vue&type=template&id=ea8aeffa&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=ea8aeffa&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8aeffa"]])

export default __exports__